import {
  getIsCarrotCardEligible,
  getMemberHasLegalPartner,
  getIsUsa,
  getSubjectToAppLockdown
} from "../../../reducers/userInfo"
import {
  getIsAvaActive,
  getSupportsDeductiblePlans,
  getHasAca,
  getCarrotLite,
  getIsSamlActive
} from "../../../reducers/companyInfo"
import { getCompanyHasExternallyManagedDeductibleEnabled } from "../../../derivedSelectors/deductibleSelectors"
import { getBenefitConfiguration } from "../../../reducers/benefitConfiguration"
import {
  updateDeductibleSourceName,
  getToggleActionForType,
  updateCustomCoverageText
} from "../../../actions/testUserActions"
import TestUserActionTypes from "actions/testUserActionTypes"
const getFeatureConfigSelector = (state) => {
  return getBenefitConfiguration(state).featureConfig
}
const getRiderConfigSelector = (state) => {
  return getBenefitConfiguration(state).rider
}
const getCoverageConfigSelector = (state) => {
  return getBenefitConfiguration(state).coverageConfig
}
const getCustomCoverage = (state) => {
  return getBenefitConfiguration(state).customCoverageText
}

const mapping = {
  carrot_card: {
    selector: (state) => getIsCarrotCardEligible(state),
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_CARROT_CARD_ELIGIBLE)
  },
  partner_feature: {
    selector: (state) => getFeatureConfigSelector(state).isPartnerEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_PARTNER_FEATURE_ENABLED)
  },
  pregnancy: {
    selector: (state) => getFeatureConfigSelector(state).isCarrotPregnancyEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_CARROT_PREGNANCY_FEATURE_ENABLED)
  },
  show_donor_content: {
    selector: (state) => getFeatureConfigSelector(state).isDonorEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_DONOR_FEATURE_ENABLED)
  },
  show_adoption_content: {
    selector: (state) => getFeatureConfigSelector(state).isAdoptionEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_ADOPTION_FEATURE_ENABLED)
  },
  member_and_partner_eligible: {
    selector: (state) => getCoverageConfigSelector(state).isMemberAndPartnerEligible,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_MEMBER_AND_PARTNER_ELIGIBLE_COVERAGE)
  },
  show_support_center: {
    selector: (state) => getFeatureConfigSelector(state).isSupportCenterEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_SUPPORT_CENTER_FEATURE_ENABLED)
  },
  show_lgbtq_content: {
    selector: (state) => getFeatureConfigSelector(state).isLgtbqEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_LGBTQ_FEATURE_ENABLED)
  },
  medically_necessary_preservation_rider: {
    selector: (state) => {
      const rider = getRiderConfigSelector(state)
      return rider && rider.hasMedicallyNecessaryPreservationRider
    },
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_HAS_MEDICALLY_NECESSARY_PRESERVATION_RIDER)
  },
  show_gestational_carrier_content: {
    selector: (state) => getFeatureConfigSelector(state).isGcEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_GC_FEATURE_ENABLED)
  },
  external_deductible: {
    selector: (state) => getCompanyHasExternallyManagedDeductibleEnabled(state),
    toggleAction: (isOn) =>
      updateDeductibleSourceName(isOn ? "ChangeHealthcareSource" : "CarrotSpecificDeductibleSource")
  },
  aca_applies: {
    selector: (state) => getHasAca(state),
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_HAS_ACA)
  },
  ava: {
    selector: (state) => getIsAvaActive(state),
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_AVA_ACTIVE)
  },
  supports_deductible_plans: {
    selector: (state) => getSupportsDeductiblePlans(state),
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_SUPPORTS_DEDUCTIBLE_PLANS)
  },
  sso: {
    selector: (state) => getIsSamlActive(state),
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_SAML_ACTIVE)
  },
  us: {
    selector: (state) => getIsUsa(state),
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_USA)
  },
  can_continue_after_rider_exhausted: {
    selector: (state) => {
      const rider = getRiderConfigSelector(state)
      return rider && rider.canContinueAfterExhausted
    },
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_CAN_CONTINUE_AFTER_EXHAUSTED_RIDER)
  },
  ivf_requirements: {
    selector: (state) => getCoverageConfigSelector(state).areIvfRequirementsEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_ARE_COVERAGE_IVF_REQUIREMENTS_ENABLED)
  },
  copay: {
    selector: (state) => getCoverageConfigSelector(state).isCopayEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_COVERAGE_COPAY_ENABLED)
  },
  infertility_dx_rider: {
    selector: (state) => {
      const rider = getRiderConfigSelector(state)
      return rider && rider.hasInfertilityDiagnosisRider
    },
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_HAS_INFERTILITY_DIAGNOSIS_RIDER)
  },
  carrot_core: {
    selector: (state) => getCarrotLite(state),
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_CARROT_LITE)
  },
  gestational_carrier_coverage: {
    selector: (state) => getCoverageConfigSelector(state).isGcEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_GC_COVERAGE_ENABLED)
  },
  elective_art: {
    selector: (state) => getCoverageConfigSelector(state).isElectiveArtEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_ELECTIVE_ART_COVERAGE_ENABLED)
  },
  infertility_diagnosis: {
    selector: (state) => getCoverageConfigSelector(state).isInfertilityDiagnosisEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_INFERTILITY_DIAGNOSIS_COVERAGE_ENABLED)
  },
  infertility: {
    selector: (state) => getCoverageConfigSelector(state).isInfertilityEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGLLE_IS_INFERTILITY_COVERAGE_ENABLED)
  },
  medically_necessary_preservation: {
    selector: (state) => getCoverageConfigSelector(state).isMedicallyNecessaryPreservationEnabled,
    toggleAction: getToggleActionForType(
      TestUserActionTypes.TOGGLE_IS_MEDICALLY_NECESSARY_PRESERVATION_COVERAGE_ENABLED
    )
  },
  elective_preservation: {
    selector: (state) => getCoverageConfigSelector(state).isElectivePreservationEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_ELECTIVE_PRESERVATION_COVERAGE_ENABLED)
  },
  adoption_coverage: {
    selector: (state) => getCoverageConfigSelector(state).isAdoptionEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_ADOPTION_COVERAGE_ENABLED)
  },
  preservation: {
    selector: (state) => getCoverageConfigSelector(state).isPreservationEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_PRESERVATION_COVERAGE_ENABLED)
  },
  carrot_rx: {
    selector: (state) => getFeatureConfigSelector(state).isCarrotRxEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_CARROT_RX_FEATURE_ENABLED)
  },
  bank_info: {
    selector: (state) => getFeatureConfigSelector(state).isBankInfoEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_BANK_INFO_FEATURE_ENABLED)
  },
  has_legal_partner: {
    selector: (state) => getMemberHasLegalPartner(state),
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_MEMBER_HAS_LEGAL_PARTNER)
  },
  donor_assistance: {
    selector: (state) => getCoverageConfigSelector(state).isDonorAssistanceEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_DONOR_ASSISTANCE_COVERAGE_ENABLED)
  },
  custom_coverage: {
    selector: (state) => getCustomCoverage(state),
    toggleAction: (isOn) =>
      updateCustomCoverageText(
        isOn
          ? "##Lorem ipsum dolor sit amet\n Nunc blandit bibendum arcu.\n\n - Proin fermentum urna.\n - Curabitur tempor augue."
          : null
      )
  },
  gross_up: {
    selector: (state) => getFeatureConfigSelector(state).isGrossUpEnabled,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_GROSS_UP_FEATURE_ENABLED)
  },
  partner_eligible_if_on_customer_medical_plan: {
    selector: (state) => getCoverageConfigSelector(state).isPartnerEligibleIfOnCustomerMedicalPlan,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_IS_PARTNER_ELIGIBLE_IF_ON_CUSTOMER_MEDICAL_PLAN)
  },
  legal_partners_eligible: {
    selector: (state) => getCoverageConfigSelector(state).areLegalPartnersEligible,
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_LEGAL_PARTNERS_ELIGIBLE)
  },
  subject_to_app_lockdown: {
    selector: (state) => getSubjectToAppLockdown(state),
    toggleAction: getToggleActionForType(TestUserActionTypes.TOGGLE_SUBJECT_TO_APP_LOCKDOWN)
  }
}

export function getConditionsSelector(dispatch): (state) => Record<string, { value: boolean; toggle: () => void }> {
  return (state) =>
    Object.keys(mapping).reduce((accumulator, key) => {
      accumulator[key] = { value: mapping[key].selector(state), toggle: () => dispatch(mapping[key].toggleAction()) }
      return accumulator
    }, {})
}

export const getToggleActionForKey = (conditionKey) => mapping[conditionKey].toggleAction
